module.exports = __webpack_public_path__ + "static/no-webcam-filler-203d4aa585ea9a5f4d45adcbd8292675.jpg";